module.exports = __webpack_public_path__ + "static/media/hunt-library-ncsu-16x9-1.c0701d92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/immersive-scholar-residency-at-ncsu/hunt-library-ncsu-16x9-1.jpg
// module id = 4140
// module chunks = 15